// extracted by mini-css-extract-plugin
module.exports = {"controls":"CompanyOverview-module__controls___YXOpc","empty":"CompanyOverview-module__empty___1DVbI","assets":"CompanyOverview-module__assets___2spxj"};